module.exports = __webpack_public_path__ + "img/partner-8.5036fffc.png";